import React, { Component } from "react";
import { Sidenav, Dropdown } from "materialize-css";
import JetMindsStart from "../../../media/images/JetMinds6.gif";
import JetMinds from "../../../media/images/JetMinds6.png";
import JetMindsStartMobile from "../../../media/images/JetMinds.gif";
import JetMindsMobile from "../../../media/images/JetMinds.png";

export class Navbar extends Component {
  constructor(props) {
    super(props);
    this.navBar = React.createRef();
    this.sideNav = React.createRef();
    this.state = {
      width: window.innerWidth,
      logoLoaded: false,
      movLogo: Math.floor(Math.random() * 15) + 1 > 10,
      scrollY: 0,
    };
  }

  componentDidMount = () => {
    Sidenav.init(this.sideNav.current);
    Dropdown.init(this.navBar.current.querySelectorAll(".dropdown-trigger"));

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));

    setTimeout(() => {
      this.setState({
        logoLoaded: true,
      });
    }, 4400);

    this.updateWindowScrolls();
    window.addEventListener("scroll", this.updateWindowScrolls.bind(this));
  };

  updateWindowScrolls = () => {
    this.setState({
      scrollY:
        this.navBar.current.parentElement.parentElement.parentElement
          .parentElement.parentElement.scrollTop,
    });
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width, logoLoaded, movLogo, scrollY } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    const scrolled = scrollY > 150;
    return (
      <React.Fragment>
        <ul id="fokusDropdown" className="dropdown-content grey darken-3">
          <li>
            <a id="overview" href="/fokusbereiche">
              Überblick
            </a>
          </li>
          <li>
            <a id="sharepoint" href="/fokusbereiche/sharepoint-online">
              SharePoint Online
            </a>
          </li>
          <li>
            <a id="powerplatform" href="/fokusbereiche/power-platform">
              Power Platform
            </a>
          </li>
          <li>
            <a id="teams" href="/fokusbereiche/microsoft-teams">
              Microsoft Teams
            </a>
          </li>
          <li>
            <a id="azure" href="/fokusbereiche/microsoft-azure">
              Microsoft Azure
            </a>
          </li>
          <li>
            <a id="software" href="/fokusbereiche/softwareentwicklung">
              Softwareentwicklung
            </a>
          </li>
          <li>
            <a id="websites" href="/fokusbereiche/webseiten">
              Webseiten
            </a>
          </li>
        </ul>
        <ul id="fokusDropdownMobile" className="dropdown-content grey darken-3">
          <li>
            <a id="overviewMobile" href="/fokusbereiche">
              Überblick
            </a>
          </li>
          <li>
            <a id="sharepointMobile" href="/fokusbereiche/sharepoint-online">
              SharePoint Online
            </a>
          </li>
          <li>
            <a id="powerplatformMobile" href="/fokusbereiche/power-platform">
              Power Platform
            </a>
          </li>
          <li>
            <a id="teamsMobile" href="/fokusbereiche/microsoft-teams">
              Microsoft Teams
            </a>
          </li>
          <li>
            <a id="azureMobile" href="/fokusbereiche/microsoft-azure">
              Microsoft Azure
            </a>
          </li>
          <li>
            <a id="softwareMobile" href="/fokusbereiche/softwareentwicklung">
              Softwareentwicklung
            </a>
          </li>
          <li>
            <a id="websitesMobile" href="/fokusbereiche/webseiten">
              Webseiten
            </a>
          </li>
        </ul>
        <nav
          className={`nav-wrapper mainNav  ${
            scrolled ? "orange darken-4" : "transparent"
          }`}
          ref={this.navBar}
        >
          <div className="nav-wrapper container">
            <a
              id="logo-container"
              href="/"
              className={isMobile ? "mobileLogo" : "logo"}
            >
              <img
                className={`responsive-img logo ${
                  scrolled && !isMobile && !isTablet ? "scrolled" : ""
                } ${scrolled && isMobile ? "scrolledMobile" : ""} ${
                  scrolled && isTablet ? "scrolledTablet" : ""
                } `}
                src={!logoLoaded && movLogo ? JetMindsStart : JetMinds}
                alt="JetMinds"
                width={isMobile ? 56 : 64}
                loading="lazy"
              />
            </a>
            <ul
              className={`right hide-on-med-and-down ${
                scrolled ? "grey darken-3" : ""
              }`}
            >
              <li>
                <a id="startsite" href="/">
                  Startseite
                </a>
              </li>
              <li>
                <a
                  id="scopes"
                  className="dropdown-trigger"
                  href="/#!"
                  data-target="fokusDropdown"
                >
                  Fokusbereiche
                  <i className="material-icons white-text right">
                    arrow_drop_down
                  </i>
                </a>
              </li>
              <li>
                <a id="products" href="/Products">
                  Produkte
                </a>
              </li>
              <li>
                <a id="insights" href="/insights">
                  Insights
                </a>
              </li>
              <li>
                <a id="consultation" href="/beratung">
                  Beratung
                </a>
              </li>
              <li>
                <a id="schooling" href="/schulungen">
                  Schulungen
                </a>
              </li>
              <li>
                <a id="blog" href="/blog">
                  Blog
                </a>
              </li>
              <li>
                <a id="contact" href="/kontakt">
                  Kontakt
                </a>
              </li>
            </ul>
            <ul
              id="nav-mobile"
              className="sidenav grey darken-3"
              ref={this.sideNav}
            >
              <li>
                <div className="user-view">
                  <div className="background orange darken-4"></div>
                  <a id="logo-containerMobile" href="/">
                    <img
                      className="responsive-img"
                      src={
                        !logoLoaded && movLogo
                          ? JetMindsStartMobile
                          : JetMindsMobile
                      }
                      alt="JetMinds"
                      width={150}
                      loading="lazy"
                    />
                  </a>
                </div>
              </li>
              <li>
                <a id="startsiteMobile" className="white-text" href="/">
                  Startseite
                </a>
              </li>
              <li>
                <a
                  id="scopesMobile"
                  className="dropdown-trigger white-text"
                  href="/#!"
                  data-target="fokusDropdownMobile"
                >
                  Fokusbereiche
                  <i className="material-icons white-text right">
                    arrow_drop_down
                  </i>
                </a>
              </li>
              <li>
                <a id="productsMobile" className="white-text" href="/products">
                  Produkte
                </a>
              </li>
              <li>
                <a id="insightsMobile" className="white-text" href="/insights">
                  Insights
                </a>
              </li>
              <li>
                <a
                  id="consultationMobile"
                  className="white-text"
                  href="/beratung"
                >
                  Beratung
                </a>
              </li>
              <li>
                <a
                  id="schoolingMobile"
                  className="white-text"
                  href="/schulungen"
                >
                  Schulungen
                </a>
              </li>
              <li>
                <a id="blogMobile" className="white-text" href="/blog">
                  Blog
                </a>
              </li>
              <li>
                <a id="contactMobile" className="white-text" href="/kontakt">
                  Kontakt
                </a>
              </li>
            </ul>
            <a
              role="button"
              data-target="nav-mobile"
              className="sidenav-trigger"
            >
              <i className="material-icons">menu</i>
            </a>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/layout/navigation/Navbar.js